import {observable} from 'mobx'

import OfferFieldValueSource from '../../class/value_source/OfferFieldValueSource'
import * as UnitMode from '../../constant/OfferCustomParamUnitMode'

let _key = 1
let _max_sort = 0

export default class OfferCustomParam {
    /** @type {OfferFieldValueSource} */
    @observable value_source = new OfferFieldValueSource()
    @observable name = ''
    @observable unit_mode = UnitMode.FROM_VALUE
    @observable custom_unit = ''
    @observable sort = 0

    _unique_key

    constructor(custom_param) {
        if (custom_param) {
            this.value_source = new OfferFieldValueSource(custom_param.value_source)
            this.name = custom_param.name
            this.unit_mode = custom_param.unit_mode
            this.custom_unit = custom_param.custom_unit
            this.sort = custom_param.sort
        }

        if (!this.sort) {
            this.sort = ++_max_sort
        }
        this._unique_key = +this.sort
        _max_sort = Math.max(_max_sort, this.sort)
    }
}